import { useRef, useState } from 'react';
import { createGlobalStore } from 'hox';

export const [useGlobalStore, getGlobalStore] = createGlobalStore(() => {
    const dragDrawerWidthConfig = useRef({
        maxWidth: document.body.clientWidth > 1350 ? 1350 : document.body.clientWidth - 70,
        minWidth: 400,
    });
    const [dragDrawerWidth, setDragDrawerWidth] = useState(
        Number(localStorage.getItem('dragDrawerWidth')) || dragDrawerWidthConfig.current.minWidth
    );
    // 外部传入的回调集合
    const externalCallbacksRef = useRef<Record<string, (data?: any) => any>>({});
    const callbacksRef = useRef<Record<string, (data: any) => void>>({});

    const subscribe = (key: string, callback: (data: any) => void) => {
        callbacksRef.current[key] = callback;
    };

    const publish = (key: string, data: any) => {
        const callback = callbacksRef.current[key];
        if (callback) {
            callback(data);
        } else {
            console.log(`${key}-未注册该回调`);
        }
    };

    const setExternalCallbacks = (callbacks: Record<string, (data: any) => any>) => {
        externalCallbacksRef.current = callbacks;
    };

    const setDragDrawerWidthForMax = () => {
        const maxWidth = dragDrawerWidthConfig.current.maxWidth;
        setDragDrawerWidth(maxWidth);
        localStorage.setItem('dragDrawerWidth', `${maxWidth}`);
    };

    const setDragDrawerWidthForMin = () => {
        const minWidth = dragDrawerWidthConfig.current.minWidth;
        setDragDrawerWidth(minWidth);
        localStorage.setItem('dragDrawerWidth', `${minWidth}`);
    };

    return {
        subscribe,
        publish,
        setExternalCallbacks,
        externalCallbacksRef,
        dragDrawerMaxWidth: dragDrawerWidthConfig.current.maxWidth,
        dragDrawerMinWidth: dragDrawerWidthConfig.current.minWidth,
        dragDrawerWidth,
        setDragDrawerWidth,
        setDragDrawerWidthForMax,
        setDragDrawerWidthForMin,
    };
});
